import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from "@air/primitive-spinner";
import { memo } from "react";
export const FileStatusIconPreparing = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsx("div", {
        "aria-hidden": true,
        className: "mr-3 flex size-10 items-center justify-center rounded-full bg-grey-4",
        children: /*#__PURE__*/ _jsx(Spinner, {
            className: "size-6",
            color: "grey"
        })
    });
});
FileStatusIconPreparing.displayName = "FileStatusIconPreparing";
